import PurchaseOrderDetailContainer from "./PurchaseOrderDetailContainer";
export default PurchaseOrderDetailContainer;
